<template>
	<div class="mxgjhrhhycx-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{ youshiInfo.title || '' }}</div>
				<div class="des">产品碳足迹核算规则和结果具备国际互认和行业采信的良好基础</div>
				<!-- 				<div class="des">{{ youshiInfo.des || '' }}</div> -->
			</div>
		</div>
		<!-- 平台遵循“国际标准+国内标准”的双轨制规则 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-3">
				<div class="section-container w1260">
					<div class="heading">平台遵循<br />“国际标准+国内标准”的双轨制规则</div>
					<div class="right-block">
						<img class="img" src="@/assets/tmp/052.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<!-- 特征 -->
		<!-- <div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-1">
				<div class="section-container">
					<div class="li">
						<div class="serial">01</div>
						<div class="content">
							<div class="label">真实活动数据</div>
							<div class="des">目标产品生产的厂内数据和生产企业有能力追溯的供应链数据</div>
						</div>
					</div>
					<div class="li">
						<div class="serial">02</div>
						<div class="content">
							<div class="label">合理量化方法学</div>
							<div class="des">生命周期影响评价方法学、共生产品的处理方式、明确系统边界、取舍规则</div>
						</div>
					</div>
					<div class="li">
						<div class="serial">03</div>
						<div class="content">
							<div class="label">高质量背景数据</div>
							<div class="des">平台内置国际知名商业数据库Ecoinvent和高质量本土数据库HiQLCD以及建设中的中国集装箱行业LCA碳足迹数据库</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- 国际标准互认具体成效 -->
		<div class="wow animate__animated animate__slideInUp" data-wow-duration="1.5s">
			<div class="section-2">
				<div class="section-container w1260">
					<div class="left-block">
						<div class="heading">真实活动数据+合理量化方法学+高质量背景数据</div>
						<!-- <div class="des">平台认证已获全球 40 + 国际认证机构广泛互认，大幅提升中国集装箱产品国际市场准入能力</div> -->
						<div class="ul">
							<div class="li">
								<div class="icon">
									<svg-icon name="mxgjhrhhycx-1"></svg-icon>
								</div>
								<div class="content">
									<div class="label">真实活动数据</div>
									<div class="value">目标产品生产的厂内数据和生产企业有能力追溯的供应链数据</div>
								</div>
							</div>
							<div class="li">
								<div class="icon">
									<svg-icon name="mxgjhrhhycx-2"></svg-icon>
								</div>
								<div class="content">
									<div class="label">合理量化方法学</div>
									<div class="value">生命周期影响评价方法学、共生产品的处理方式、明确系统边界、取舍规则</div>
								</div>
							</div>
							<div class="li">
								<div class="icon">
									<svg-icon name="mxgjhrhhycx-5"></svg-icon>
								</div>
								<div class="content">
									<div class="label">高质量背景数据</div>
									<div class="value">平台内置国际知名商业数据库Ecoinvent和高质量本土数据库HiQLCD以及建设中的中国集装箱行业LCA碳足迹数据库</div>
								</div>
							</div>
						</div>
					</div>
					<div class="right-block">
						<!-- <div class="statistics">
							<div class="li">
								<div class="num">40+</div>
								<div class="text">平台认证已获国际认证机构广泛互认</div>
							</div>
							<div class="li">
								<div class="num">100+</div>
								<div class="text">平台连接产业链上下游企业</div>
							</div>
						</div> -->
						<div class="pic scale-img">
							<img class="img" src="@/assets/tmp/043.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
import { webInfo } from '@/common/data.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
export default {
	name: 'mxgjhrhhycx',
	components: { Head, Foot },
	data() {
		return {
			youshiInfo: webInfo.pingtaiyoushi[3]
		};
	},
	created() {},
	mounted() {
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		}
	}
};
</script>

<style lang="scss" scoped>
.mxgjhrhhycx-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		// background-image: url('~@/assets/tmp/027.png');
		background-size: cover;
		height: 233px;
		background-color: #29965c;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			padding-right: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 87px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
				text-align: center;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
				text-align: center;
			}
		}
	}

	.section-1 {
		background: #ffffff;
		padding-top: 50px;
		padding-bottom: 50px;
		.section-container {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			.li {
				width: calc(100% / 3);
				display: flex;
				height: 223px;
				background: #ffffff;
				border: 1px solid rgba(223, 223, 223, 0.7);
				padding-top: 60px;
				padding-bottom: 60px;
				box-sizing: border-box;
				.serial {
					width: 152px;
					display: flex;
					justify-content: flex-end;
					padding-right: 38px;
					box-sizing: border-box;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 24px;
					color: #262729;
					line-height: 33px;
					text-align: right;
				}
				.content {
					flex: 1;
					display: flex;
					flex-direction: column;
					padding-right: 33px;
					.label {
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
					}
					.des {
						margin-top: 23px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 14px;
						color: rgba(#262729, 0.7);
						line-height: 20px;
						text-align: justify;
					}
				}
			}
		}
	}

	.section-2 {
		background: #f9fafb;
		padding-top: 48px;
		padding-bottom: 109px;
		.section-container {
			display: flex;
			.left-block {
				display: flex;
				flex-direction: column;
				width: 539px;
				.heading {
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 30px;
					color: #262729;
					line-height: 42px;
					white-space: nowrap;
				}
				.des {
					margin-top: 32px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 17px;
					color: rgba(#262729, 0.7);
					line-height: 24px;
				}
				.ul {
					margin-top: 140px;
					display: flex;
					flex-direction: column;
					.li {
						display: flex;
						margin-bottom: 70px;
						&:last-child {
							margin-bottom: 0;
						}
						.icon {
							.svg-icon {
								display: inline-block;
								width: 50px;
								height: 50px;
							}
						}
						.content {
							padding-left: 44px;
							display: flex;
							flex-direction: column;
							.label {
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								font-size: 24px;
								color: #262729;
								line-height: 33px;
							}
							.value {
								margin-top: 5px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 400;
								font-size: 14px;
								color: rgba(#262729, 0.7);
								line-height: 20px;
							}
						}
					}
				}
			}
			.right-block {
				margin-left: auto;
				display: flex;
				align-items: flex-start;
				padding-top: 60px;
				.statistics {
					position: relative;
					z-index: 1;
					margin-top: 102px;
					display: flex;
					flex-direction: column;
					width: 320px;
					// min-height: 420px;
					background: #29965c;
					box-shadow: 0px 49px 90px 0px rgba(41, 150, 92, 0.33);
					margin-right: -125px;
					padding-top: 38px;
					padding-left: 55px;
					padding-right: 55px;
					padding-bottom: 20px;
					box-sizing: border-box;
					.li {
						display: flex;
						flex-direction: column;
						margin-bottom: 52px;
						.num {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 43px;
							color: #ffffff;
							line-height: 61px;
						}
						.text {
							margin-top: 15px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 19px;
							color: rgba(#ffffff, 0.7);
							line-height: 26px;
						}
					}
				}
				.pic {
					img {
						display: block;
						width: 435px;
						height: 574px;
					}
				}
			}
		}
	}
	
	.section-3 {
		background: #ffffff;
		.section-container {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			.heading {
				margin-top: 90px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 30px;
				color: #262729;
				line-height: 42px;
			}
			.right-block {
				margin: 20px 115px 20px 0;
				img {
					width: 265px;
					height: 265px;
				}
			}
		}
	}
}
</style>
